import Boat from '@/models/Boat'
import User, { hasRole, Role } from '@/models/User'

export default class BoatPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, boat: Boat) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === boat.entry.catalog.company.id
			case Role.AUDITOR:
				return boat.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, boat: Boat) {
		return hasRole(user, Role.USER) && user.company?.id === boat.entry.catalog.company.id
	}

	restore(user: User, boat: Boat) {
		return hasRole(user, Role.USER) && user.company?.id === boat.entry.catalog.company.id
	}

	delete(user: User, boat: Boat) {
		return hasRole(user, Role.USER) && user.company?.id === boat.entry.catalog.company.id
	}

	forceDelete(_user: User, _boat: Boat) {
		return false
	}
}
